<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/D5N6Cx/tc-custom/9781540265081.jpg?1737196545398" alt="This image is the cover for the book Joe Biden's Delaware, History & Guide"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Joe Biden's Delaware, History & Guide
      </h1>
      <p class="bookDescription body article font2">
        <p>"Delaware will be written on my heart."   In 1972, a young Delaware attorney made an audacious bet, challenging the state's most formidable politician in a race for the US Senate. Joe Biden won that election at age twenty-nine, but weeks later, his wife and daughter died in a car crash that also injured his two sons. This is the story of Delaware's preeminent political leader, his family and their journey over the decades since. From the Charcoal Pit to the Hotel DuPont, St. Joseph's on the Brandywine to the Wilmington train station, these tales reveal Joe Biden's deep roots in Delaware and how they helped carry him to the White House. Author Dan Shortridge examines Biden family lore and traces the history of the institutions that shaped their lives and the First State.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dan Shortridge
      </h2>
      
      <p class="authorDescription body article">Dan Shortridge works in communications and marketing by day and history by night. He is the coauthor of several other local interest books, including most recently Lost Delaware . He has led public relations and communications for several state agencies, worked for a regional marketing firm and covered Delaware stories for two newspapers. Dan enjoys the outdoors, traveling and discovering new places to eat. The father of three, he is married to fellow author Rachel Kipp.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?044ceeac